<template>
  <div class="apply-return">
    <div class="title_nav">
      <div @click="$router.go(-1)">
        <Icon name="arrow-left" style="margin-top:0.1rem" />
      </div>
      <div style="padding-top:0.05rem" class="nav_address">售后申请</div>
    </div>
    <!-- 旧商品信息 -->
    <!-- <div
      class="goodsStyle acea-row row-between"
      v-for="cart in orderInfo.cartInfo"
      :key="cart.id"
    >
      <div class="pictrue">
        <img :src="cart.productInfo.image" class="image" />
      </div>
      <div class="text acea-row row-between">
        <div class="name line2">{{ cart.productInfo.store_name }}</div>
        <div class="money">
          <div>
            {{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}
          </div>
          <div class="num">x{{ cart.cart_num }}</div>
        </div>
      </div>
    </div> -->
    <!-- 新商品信息 -->
    <div class="detalis_box">
      <div class="quantity">退款商品</div>
      <div class="quantit" v-for="cart in orderInfo.cartInfo" :key="cart.id">
        <div>
          <img :src="cart.productInfo.image" alt="" />
        </div>
        <div class="quantiy">
          <div>{{ cart.productInfo.store_name }}</div>
          <div class="quan">
            <div class="tity">
              <div><img src="@/assets/images/icon-money.png" alt=""></div>
              <div>{{ orderInfo.pay_price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 旧退货原因 -->
    <!-- <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>退货件数</div>
        <div class="num">{{ orderInfo.total_num }}</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>退款金额</div>
        <div class="num">{{ orderInfo.pay_price }}</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>退款原因</div>
        <div class="num acea-row row-left">
          <select v-model="reason">
            <option value="">选择退款原因</option>
            <option
              v-for="(text, index) in reasonList"
              :value="text"
              :key="index"
            >
              {{ text }}
            </option>
          </select>
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <div class="item textarea acea-row row-between">
        <div>备注说明</div>
        <textarea
          placeholder="填写备注信息，100字以内"
          class="num"
          v-model="refund_reason_wap_explain"
        ></textarea>
      </div>
      <div class="item acea-row row-between">
        <div class="title acea-row row-between-wrapper">
          <div>上传凭证</div>
          <div class="tip">( 最多可上传3张 )</div>
        </div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in refund_reason_wap_img"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="refund_reason_wap_img.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="refund_reason_wap_img.length < 3"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
    </div> -->
<!-- 新退货原因 -->
    <div class="refundlist">
      <div class="refundtitle">退款信息</div>
      <div style="display:flex">
        <div class="refundReason">退款原因</div>
        <Field class="reasons" readonly clickable name="picker" :value="value" placeholder="请选择 〉"
          @click="showPicker = true" />
        <Popup v-model="showPicker" position="bottom">
          <Picker show-toolbar :columns="reasonList" @confirm="onConfirm" @cancel="showPicker = false" />
        </Popup>
      </div>
      <div style="padding-bottom:0.2rem">
        <div class="refundReason">退款说明</div>
        <Field class="refundinput" v-model="refund_reason_wap_explain" rows="1" autosize type="textarea" placeholder="请输入退款说明" />
      </div>
      <div>
        <div class="refundReason">上传凭证</div>
        <div style="display:flex;">
          <VueCoreImageUpload :crop="false" compress="80" @imageuploaded="imageuploaded" :headers="headers"
            :max-file-size="5242880" :credentials="false" inputAccept="image/*" inputOfFile="file" :url="url"
            v-if="refund_reason_wap_img.length < 3">
            <div class="uploadPhoto">
              <img src="@assets/images/order_upload.png" class="uploadIcon" alt="" />
            </div>
          </VueCoreImageUpload>
          <div class="pictrue" v-for="(img, index) in refund_reason_wap_img" :key="img">
            <img :src="img" />
            <div class="iconfont icon-guanbi1 font-color-red" @click="refund_reason_wap_img.splice(index, 1)"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="returnBnt bg-color-red" @click="submit">提交</div>
  </div>
</template>

<script>
import { orderDetail, getRefundReason, postOrderRefund } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { Icon, Field, Popup, Picker } from "vant";
export default {
  name: "goodsReturn",
  components: {
    VueCoreImageUpload, Icon, Field, Popup, Picker
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      orderInfo: {},
      reasonList: [],
      reason: "",
      refund_reason_wap_explain: "",
      refund_reason_wap_img: [],
      value: "",
      showPicker: false
    };
  },
  methods: {
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    getOrderDetail() {
      orderDetail(this.id)
        .then(res => {
          this.orderInfo = res.data;
        })
        .catch(err => {
          this.$dialog.error(err.msg || "获取订单失败");
        });
    },
    getRefundReason() {
      getRefundReason().then(res => {
        this.reasonList = res.data;
      });
    },
    submit() {
      const refund_reason_wap_explain = trim(this.refund_reason_wap_explain),
        text = this.value;
      if (!text) return this.$dialog.toast({ mes: "请选择退款原因" });
      postOrderRefund({
        text,
        uni: this.orderInfo.order_id,
        refund_reason_wap_img: this.refund_reason_wap_img.join(","),
        refund_reason_wap_explain
      })
        .then(res => {
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    }
  },
  mounted() {
    this.getOrderDetail();
    this.getRefundReason();
  }
};
</script>
<style scoped>
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.title_nav {
  display: flex;
  width: 100%;
  /* background: #fff; */
  height: 0.7rem;
  padding-left: 0.2rem;
  padding-top: 0.15rem;
  background: white;
  margin-bottom: 0.3rem;
}

.nav_address {
  width: 80%;
  text-align: center;
  margin-left: 0.4rem;
}

.detalis_box {
  width: 90%;
  background: white;
  margin-left: 0.4rem;
  margin-top: 0.2rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
}

.quantity {
  padding: 0.3rem;
  font-size: 0.3rem;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #242424;
}

.quantit {
  display: flex;
  margin-left: 0.3rem;
}

.quantit img {
  width: 1rem;
  height: 1rem;
}

.quantiy {
  width: 100%;
  margin-left: 0.2rem;
  text-align: left;
}

.quantiy div:nth-child(1) {
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #242424;
  width: 100%;
  font-size: 0.25rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.quan {
  margin-top: 0.2rem;
}

.tity {
  color: #ee453e !important;
  display: flex !important;
  width: 21% !important;
}

.tity img {
  width: 0.35rem;
  height: 0.35rem;
}

.refundlist {
  width: 90%;
  background: white;
  margin-left: 0.4rem;
  margin-top: 0.2rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
  padding-bottom: 0.3rem;
}

.refundtitle {
  padding: 0.3rem;
  font-size: 0.3rem;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #242424;
}

.refundReason {
  margin-left: 0.3rem;
  margin-top: 0.3rem;
  font-size: 0.25rem;
}

.refundinput {
  width: 90%;
  height: 1.5rem;
  background: #f5f5f5;
  margin-top: 0.2rem;
  margin-left: 0.3rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
}

.reasons {
  width: 5.4rem;
  border: none;
}

::v-deep .reasons .van-field__control::-webkit-input-placeholder {
  color: #666666;
  font-size: 0.25rem;
  text-align: right;
}

.uploadPhoto {
  width: 1rem;
  height: 1rem;
  text-align: center;
  padding-top: 0.15rem;
  background: #f5f5f5;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
  margin-left: 0.3rem;
  margin-top: 0.3rem;
}

.uploadIcon {
  width: 0.7rem;
  height: 0.7rem;
}

.pictrue {
  position: relative;
}

.pictrue img {
  width: 1rem;
  height: 1rem;
  margin-left: 0.2rem;
  margin-top: 0.3rem;
  display: block;
}

.pictrue .icon-guanbi1 {
  position: absolute;
  top: 0.1rem;
}
</style>
